<div class="error-screen">
  <mat-icon svgIcon="session"></mat-icon>
  <div class="text-container">
    <span class="title">Sua sessão será encerrada em {{timeout}} segundos.</span>
    <span class="subtitle">Para manter sua sessão ativa, clique em "continuar".</span>
    <button (click)='onClick()' mat-raised-button color="primary02" class="sm">Continuar</button>
  </div>
</div>